var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardIconOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#D88C0D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4997 6.25H9.16634V5.66667H11.4997V6.25ZM4.20801 4.5C3.72493 4.5 3.33301 4.89193 3.33301 5.375V6.54167C3.33301 7.02474 3.72493 7.41667 4.20801 7.41667H11.7913C12.2744 7.41667 12.6663 7.02474 12.6663 6.54167V5.375C12.6663 4.89193 12.2744 4.5 11.7913 4.5H4.20801ZM11.4997 9.75V10.3333H6.83301V9.75H11.4997ZM4.20801 8.58333C3.72493 8.58333 3.33301 8.97526 3.33301 9.45833V10.625C3.33301 11.1081 3.72493 11.5 4.20801 11.5H11.7913C12.2744 11.5 12.6663 11.1081 12.6663 10.625V9.45833C12.6663 8.97526 12.2744 8.58333 11.7913 8.58333H4.20801Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIconOne);
export default __webpack_public_path__ + "static/media/cardIconOne.270c0a25c1080ad440ce10dbc9f4f9ca.svg";
export { ForwardRef as ReactComponent };